import { render, staticRenderFns } from "./BudgetDashboardDepartmentSelector.vue?vue&type=template&id=740bfcfb&scoped=true&"
import script from "./BudgetDashboardDepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboardDepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDashboardDepartmentSelector.vue?vue&type=style&index=0&id=740bfcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740bfcfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740bfcfb')) {
      api.createRecord('740bfcfb', component.options)
    } else {
      api.reload('740bfcfb', component.options)
    }
    module.hot.accept("./BudgetDashboardDepartmentSelector.vue?vue&type=template&id=740bfcfb&scoped=true&", function () {
      api.rerender('740bfcfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/BudgetDashboardDepartmentSelector.vue"
export default component.exports